import { Component, Prop, Vue } from "vue-property-decorator";
import { Icon } from "ant-design-vue";
import { LessonPlanLocale } from "@/locales/localeid";
import LabelText from "@/components/label-text/label-text.vue";
import { GLUtil } from "commonui";

@Component({
	components: {
		LabelText,
		Icon
	}
})
export default class UnitInfo extends Vue {
	@Prop() label!: string;
	@Prop() unitText!: string;
	@Prop() mothodologyText!: string;
	@Prop() lessonPlanVersionText!: string;
	@Prop() lessonPlanText!: string;
	@Prop({ default: false }) isREP?: boolean;
	@Prop() onPressEdit!: () => void;
	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}
	get hasEditButton() {
		return !!this.onPressEdit;
	}
	get hasLessonPlanText() {
		return !GLUtil.isNullOrUndefined(this.lessonPlanText);
	}
}
